import React, { useEffect, useState } from 'react';
import styles from './enrichment-ip-information.module.sass';
import { Button, Typography, Tooltip, Divider, Table } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import Tag from '../../../../shared-components/Tag';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import { formatDate } from '../../../../redux/utils/date';
import { STATUS } from '../../../../redux/constants';
import { Link } from 'react-router-dom';

function EnrichmentIpInformation({
  props,
  newData,
  statusNew,
  oldData,
  statusOld,
  parsedData,
}) {
  const { Title, Paragraph, Text } = Typography;
  let ipInformation = undefined;
  if (newData?.response?.ip2asn) {
    ipInformation = newData?.response?.ip2asn?.[0];
  }
  const [userTags, setUserTags] = useState();

  useEffect(() => {
    if (
      oldData?.feeds_containing_ioc?.length > 0 &&
      statusOld === STATUS.LOADED
    ) {
      getUserTags(oldData?.feeds_containing_ioc);
    }
  }, [oldData, statusOld]);

  //an array of objects is created to hold the "feed structure" to help distinguish if the tag is from a collection or a feed, to apply an extra param on click
  function getUserTags(feed) {
    if (!feed?.length) return;
    let tagsArray = [];
    for (let i in feed) {
      tagsArray.push({
        user_tags: feed?.[i]?.user_tags,
        state: feed?.[i]?.state,
      });
    }
    tagsArray = tagsArray?.flat();
    setUserTags(tagsArray);
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Threat Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (value, params) => {
        if (params?.tooltip) {
          return (
            <>
              {value + ' '}
              <Tooltip placement="top" title={params?.tooltip}>
                <InfoCircleFilled />
              </Tooltip>
            </>
          );
        } else {
          return value;
        }
      },
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
      className: 'ant-column-white',
      render: (value, params) => {
        if (statusNew === 'loaded' || statusOld === 'loaded') {
          if (params?.usertag) {
            //check if there are user tags
            if (value && value?.some((item) => item?.user_tags?.length > 0)) {
              //this one is looping through the array of object (of tags)
              return value?.map((elem) =>
                //looping through the user tags per feed/collection
                elem?.user_tags?.map((tag) => (
                  <Tag
                    tag={{ name: tag }}
                    tagColor={'gold'}
                    canClick={
                      props.mySubscriptionPlan?.has_access_to_threat_ranking
                        ? true
                        : false
                    }
                    isTagManuallyCreated={false}
                    canRemove={false}
                    extraParams={
                      elem?.state === 'COLLECTION'
                        ? '&feed_state=COLLECTION'
                        : ''
                    }
                    filterProfileToBeCleared={true}
                    showTooltip={
                      !props.mySubscriptionPlan?.has_access_to_threat_ranking
                    }
                    tooltipText={
                      <>
                        Filtering on tags is not part of this subscription plan.
                        To upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    }
                  />
                )),
              );
            }
            //if no user tag is found, return "-"
            else {
              return '-';
            }
          } else {
            return value;
          }
        } else {
          return <LoadingSkeleton />;
        }
      },
    },
  ];

  function returnTableData({ loading }) {
    return [
      {
        key: 1,
        name: 'Date',
        usertag: false,
        tooltip: null,
        value: loading ? (
          <LoadingSkeleton />
        ) : ipInformation?.date ? (
          formatDate(ipInformation?.date)
        ) : (
          '-'
        ),
      },
      {
        key: 2,
        name: 'User Tags',
        usertag: true,
        tooltip: (
          <Paragraph className="m-0">
            Individual observable’s tags user added
          </Paragraph>
        ),
        value: userTags ? userTags : [],
      },
      {
        key: 3,
        name: 'ASN',
        usertag: false,
        tooltip: (
          <Paragraph className="m-0">
            The number of the AS, allocated by IANA
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : ipInformation?.asn ? (
          ipInformation?.asn
        ) : (
          '-'
        ),
      },
      {
        key: 4,
        name: 'AS Name',
        usertag: false,
        tooltip: <Paragraph className="m-0">The name of the AS</Paragraph>,
        value: loading ? (
          <LoadingSkeleton />
        ) : ipInformation?.asname ? (
          ipInformation?.asname
        ) : (
          '-'
        ),
      },
      {
        key: 5,
        name: 'Subnet',
        usertag: false,
        tooltip: <Paragraph className="m-0">The IP addresses subnet</Paragraph>,
        value: loading ? (
          <LoadingSkeleton />
        ) : ipInformation?.subnet ? (
          ipInformation?.subnet
        ) : (
          '-'
        ),
      },
      {
        key: 6,
        name: 'IP Density',
        usertag: false,
        tooltip: (
          <Paragraph className="m-0">
            The amount of domains pointing to an IP address
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <>
            <Text className={'me-1'} strong>
              {ipInformation?.density || ipInformation?.density == 0
                ? ipInformation?.density
                : oldData?.ip_density || oldData?.ip_density == 0
                ? oldData?.ip_density
                : '-'}
            </Text>
            {props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    ipInformation?.ip ?? parsedData?.result
                  }&queryType=query&type=ANYIPV4&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            )}
          </>
        ),
      },
      {
        key: 7,
        name: 'IP PTR',
        usertag: false,
        tooltip: (
          <Paragraph className="m-0">
            A PTR record pointing to an IP address
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <>
            <Text className={'me-1'} strong>
              {ipInformation?.ip_ptr ? ipInformation?.ip_ptr : '-'}
            </Text>
            {props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={
                  `/explore-result?name=${
                    ipInformation?.ip ?? parsedData?.result
                  }&queryType=query&type=PTR4&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search) +
                  '&origin_uid=Explore'
                }
              >
                <Button type="primary">Lookup PADNS</Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button disabled type="primary">
                  Lookup PADNS
                </Button>
              </Tooltip>
            )}
          </>
        ),
      },
    ];
  }

  return (
    <div
      id="enrichmentIpInformation"
      className={styles.enrichment_ip_information}
    >
      <Title level={4}>IP Information</Title>
      <Table
        columns={columns}
        dataSource={returnTableData({
          loading: statusNew === 'loading',
        })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentIpInformation;
